import { render, staticRenderFns } from "./ChatEmojiButton.vue?vue&type=template&id=492cf6f3&scoped=true&"
import script from "./ChatEmojiButton.vue?vue&type=script&lang=js&"
export * from "./ChatEmojiButton.vue?vue&type=script&lang=js&"
import style0 from "./ChatEmojiButton.vue?vue&type=style&index=0&id=492cf6f3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492cf6f3",
  null
  
)

export default component.exports